import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToSection } from "../lib/scroll";

const MAIN = [
    {
        key: "christ",
        name: "Christ Wash Systems",
        role: "Concessionario Ufficiale Calabria",
        tag: "Portali, tunnel, self-service, lavaggio mezzi pesanti e coperture esterne. Ingegneria tedesca dal 1963.",
        logo: "/brands/christ-logo.png",
        img: "/christ/vega.jpg",
        target: "christ",
        cta: "Scopri la gamma Christ",
    },
    {
        key: "ravaglioli",
        name: "Ravaglioli",
        role: "Partner Officina",
        tag: "Ponti sollevatori, colonne mobili, smontagomme, equilibratrici, assetto ruote e linee revisione. Made in Italy.",
        logo: "/brands/ravaglioli-logo-dark.png",
        img: "/officina/officina-ravaglioli.jpg",
        target: "autoriparatore",
        cta: "Scopri la divisione officina",
    },
];

const OTHERS = [
    { key: "beta", name: "Beta Utensili", tag: "utensileria e arredo" },
    { key: "comet", name: "Comet", tag: "idropulitrici" },
    { key: "abac", name: "ABAC", tag: "compressori" },
    { key: "filcar", name: "Filcar", tag: "aspirazione gas" },
    { key: "idroconsult", name: "Idroconsult", tag: "depurazione acque" },
];

export const Marchi = () => (
    <section
        id="marchi"
        data-testid="marchi-section"
        className="bg-white py-20 lg:py-24"
    >
        <div className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16">
            <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
                <div className="max-w-xl">
                    <Reveal>
                        <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#E30613]">
                            I nostri partner
                        </span>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-4xl">
                            Due leader europei, un partner tecnico presente in tutto il Sud Italia.
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.15}>
                    <p className="max-w-md text-sm leading-relaxed text-[#4F5D70] sm:text-base">
                        Christ per il lavaggio, Ravaglioli per l'officina: qualità certificata,
                        ricambi originali e assistenza diretta dei nostri tecnici.
                    </p>
                </Reveal>
            </div>

            <div className="mt-12 grid gap-6 lg:grid-cols-2">
                {MAIN.map((b, i) => (
                    <Reveal key={b.key} delay={0.05 + i * 0.1}>
                        <article
                            data-testid={`brand-card-${b.key}`}
                            onClick={() => scrollToSection(b.target)}
                            className="group relative h-full cursor-pointer overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_10px_30px_-5px_rgba(11,31,58,0.08)] transition-[box-shadow,transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-[#E30613]/30 hover:shadow-[0_28px_60px_-16px_rgba(11,31,58,0.2)]"
                        >
                            <div className="relative h-56 overflow-hidden sm:h-64">
                                <img
                                    src={b.img}
                                    alt={b.name}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1F3A]/70 via-[#0B1F3A]/10 to-transparent" />
                                <span className="absolute left-5 top-5 rounded-full bg-[#E30613] px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white">
                                    {b.role}
                                </span>
                                <div className="absolute bottom-5 left-5 rounded-xl bg-white px-4 py-2.5 shadow-lg">
                                    <img src={b.logo} alt={b.name} className="h-8 w-auto" />
                                </div>
                            </div>
                            <div className="p-7">
                                <h3 className="font-display text-2xl font-extrabold tracking-tight text-[#0B1F3A]">
                                    {b.name}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-[#4F5D70] sm:text-base">
                                    {b.tag}
                                </p>
                                <div className="mt-5 flex items-center gap-2 text-sm font-bold text-[#0B1F3A]">
                                    {b.cta}
                                    <ArrowRight className="h-4 w-4 text-[#E30613] transition-transform duration-300 group-hover:translate-x-1" />
                                </div>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div
                    data-testid="other-brands-strip"
                    className="mt-10 flex flex-col gap-3 rounded-2xl border border-slate-200/80 bg-white/60 px-5 py-4 sm:flex-row sm:items-center sm:gap-6"
                >
                    <span className="shrink-0 text-[10px] font-bold uppercase tracking-[0.18em] text-[#94A3B8]">
                        Trattiamo inoltre
                    </span>
                    <ul className="flex flex-wrap gap-x-5 gap-y-2">
                        {OTHERS.map((o) => (
                            <li
                                key={o.key}
                                data-testid={`other-brand-${o.key}`}
                                className="text-xs text-[#4F5D70]"
                            >
                                <span className="font-semibold text-[#475569]">{o.name}</span>{" "}
                                <span className="text-[#94A3B8]">· {o.tag}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </Reveal>
        </div>
    </section>
);
